import { END_POINTS } from "../constants/url";
import { RefundData } from "../types/General";

import emptySplitApi from "../utils/rtk";

type RefundListResponse = {
  list: RefundData[];
  totalCount: number;
};

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: RefundListResponse[];
};
type Refund = {
  bookingId: string;
  walletAmount: number;
  refundAmount: number;
};

export const RefundApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRefundList: builder.query<
      CommonResponseType,
      {
        page: number;
        limit: number;
        search: string;
        status: number;
      }
    >({
      query: ({ page, limit, search, status }) => ({
        url: `${
          END_POINTS.refundList
        }?status=${status}&page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    addRefund: builder.mutation<CommonResponseType, { data: Refund }>({
      query: (body) => ({
        url: END_POINTS.refund,
        method: "POST",
        body: body?.data,
      }),
    }),
  }),
});
export const { useLazyGetRefundListQuery, useAddRefundMutation } = RefundApi;
